var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfilledStarLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star 3",
    filter: "url(#filter0_d_352_1985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2161 4.45072C15.6202 3.20695 17.3798 3.20695 17.7839 4.45072L19.7092 10.376C20.0104 11.303 20.8743 11.9307 21.849 11.9307H28.0792C29.387 11.9307 29.9307 13.6041 28.8727 14.3728L23.8324 18.0348C23.0438 18.6078 22.7138 19.6234 23.015 20.5504L24.9403 26.4756C25.3444 27.7194 23.9208 28.7537 22.8628 27.985L17.8225 24.323C17.0339 23.75 15.9661 23.75 15.1775 24.323L10.1372 27.985C9.07917 28.7537 7.65562 27.7194 8.05974 26.4756L9.98497 20.5504C10.2862 19.6234 9.9562 18.6078 9.16761 18.0348L4.12731 14.3728C3.06929 13.6041 3.61304 11.9307 4.92081 11.9307H11.151C12.1257 11.9307 12.9896 11.303 13.2908 10.376L15.2161 4.45072Z",
    stroke: "black",
    strokeWidth: 0.9,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_352_1985",
    x: 0.717188,
    y: 0.667871,
    width: 31.5656,
    height: 30.4331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_352_1985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_352_1985",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledStarLarge);
export default __webpack_public_path__ + "static/media/unfilledStarLarge.710ee67cd4e2eac03a37e3ce25daa306.svg";
export { ForwardRef as ReactComponent };